import Header from "../headerAuthenticated/HeaderAuthenticated.vue"
import ResponsiveFooter from "../responsivefooter/ResponsiveFooter.vue"
import '../../mixins.js'
import ResponsiveHeader from "../responsiveheader/ResponsiveHeader.vue"
import ResponsiveHeaderMobile from "../ResponsiveHeaderMobile/ResponsiveHeaderMobile.vue"
//import axios from 'axios'
import CookieLaw from 'vue-cookie-law'
import Vuetable from 'vuetable-2'
import spinner from "../LoadingComponent/LoadingComponent.vue"
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetableRowHeader from "vuetable-2/src/components/VuetableRowHeader.vue";
import _ from "lodash";

export default {
  name: 'security-ranking',
  components: {
    Header: Header,
    responsivefooter: ResponsiveFooter,
    responsiveheader: ResponsiveHeader,
    responsiveheadermobile: ResponsiveHeaderMobile,
    CookieLaw,
    Vuetable,
    VuetablePagination,
    VuetableRowHeader,
    spinner
  },
  props: [],
  data () {
    return {
      data: [],
      securityDataKeys: [],
      isLoaded: false,
      perPage: 15,
      dropdownOptions: [],
      queryParams: {
        country: '',
        industry: '',
        region: '',
        sector: '',
        security_type: ''
      },
      inputName: '',
      isEndpointError: false,
      showButtonSpinner: false,
      emptyOption: "",
      isMobile: false,
      isFiltersOpen: false,
      broker_list: [],
      isBrokerListEmpty: true,
    }
  },
  computed: {

  },
  watch: {
    data(newVal, oldVal) {
      console.log(newVal, oldVal)
      if(this.$refs.vuetable){
        this.$refs.vuetable.refresh();
      }
      
    }
  },
  async created () {
    this.verifyTokenNoRouting();
    this.enablePlugin();
    try{
      this.dropdownOptions = await this.accessEndpoint('filterOptionsRanking/')
      console.log('dropdown options:', this.dropdownOptions)
      this.setBrokerList();
      if(this.dropdownOptions.user_brokers.length > 0){
        this.isBrokerListEmpty = false;
      }
    }
    catch{
      this.showErrorNotification()
    }
    this.showButtonSpinner = true
    this.isLoaded = true

    try{
      var payload
      if (localStorage.getItem("assetRankingSearch") === null) {
        payload = {
          "name": {"min": "", "max": ""},
          "isin": {"min": "", "max": ""},
          "technical_probability": {"min": "", "max": ""},
          "long_trend": {"min": "", "max": ""},
          "trend_break": {"min": "", "max": ""},
          "security_type": {"min": "", "max": ""},
          "region": {"min": "", "max": ""},
          "country": {"min": "", "max": ""},
          "sector": {"min": "", "max": ""},
          "industry": {"min": "", "max": ""},
          "brokers": this.dropdownOptions.user_brokers
        }
      }
      else{
        payload = JSON.parse(localStorage.getItem("assetRankingSearch"))
        this.inputName = payload.name.like
        this.queryParams.security_type = payload.security_type.equals
        this.queryParams.region = payload.region.equals
        this.queryParams.country = payload.country.equals
        this.queryParams.sector = payload.sector.equals
        this.queryParams.industry = payload.industry.equals
      }

      this.data = await this.postEndpoint(payload,'securityRanking/');
      this.getTableHeader()
    }
    catch{
      this.showErrorNotification()
    }
    this.showButtonSpinner = false

  },
  mounted () {
    this.isMobile = window.innerWidth <= 900;
  },
  methods: {
    async fetchData(){
      let selected_brokers = this.saveBrokers();
      let payload = {
        "name": {"min": "", "max": "", "like": this.inputName},
        "isin": {"min": "", "max": ""},
        "technical_probability": {"min": "", "max": ""},
        "long_trend": {"min": "", "max": ""},
        "trend_break": {"min": "", "max": ""},
        "security_type": {"min": "", "max": "", "equals": this.queryParams.security_type},
        "region": {"min": "", "max": "", "equals": this.queryParams.region},
        "country": {"min": "", "max": "", "equals": this.queryParams.country},
        "sector": {"min": "", "max": "", "equals": this.queryParams.sector},
        "industry": {"min": "", "max": "", "equals": this.queryParams.industry},
        "brokers": selected_brokers
      }
      localStorage.setItem('assetRankingSearch', JSON.stringify(payload)) 
      console.log("post payload: ", payload)
      try{
        this.showButtonSpinner = true;
        await this.verifyToken();
        this.data = await this.postEndpoint(payload,'securityRanking/');

        if(selected_brokers.length > 0){
          this.isBrokerListEmpty = false;
        }else{
          this.isBrokerListEmpty = true;
        }
        if (this.data.length > 0){
          this.getTableHeader()
        }
        
      }
      catch{
        this.showErrorNotification()
      }
      this.showButtonSpinner = false;
      
    },
    saveBrokers(){
      var selected_brokers = [];
      this.broker_list.forEach(broker_json => {
        if(broker_json.active == true){
          selected_brokers.push(broker_json.name)
        }
      })
      return selected_brokers
    },
    getTableHeader(){
      let tempKeys = Object.keys(this.data[0])
      let tempKey = ''
      this.securityDataKeys = []
      this.securityDataKeys.push({name: "short_name", sortField: "short_name", title: "Name"})
      tempKeys.forEach(key => {
        if(!key.includes("name")){
          tempKey = key.replace('_', ' ')
          tempKey = tempKey.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ');
          this.securityDataKeys.push({name: key, sortField: key, title: tempKey})
        }
      })
    },
    routeAssetDetail(item) {
      console.log(item.data);
      this.$router.push("/assetDetail/" + item.data.isin);
    },
    removeFilters(){
      for (var key in this.queryParams) {
        this.queryParams[key] = this.emptyOption;
      }
      this.inputName = this.emptyOption
    },
    setBrokerList(){
      let available_brokers = this.dropdownOptions.available_brokers
      let brokers = this.dropdownOptions.user_brokers
      this.broker_list = []
      available_brokers.forEach(broker => {
        this.broker_list.push({name:broker, active: brokers.includes(broker)})
      })
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    dataManager(sortOrder, pagination) {
      if (this.data.length < 1) return;

      let local = this.data;

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        console.log("orderBy:", sortOrder[0].sortField, sortOrder[0].direction);
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }

      pagination = this.$refs.vuetable.makePagination(
        local.length,
        this.perPage
      );
      console.log('pagination:', pagination)
      let from = pagination.from - 1;
      let to = from + this.perPage;

      return {
        pagination: pagination,
        data: _.slice(local, from, to)
      };
    },
  }
}


